import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import moment from "moment";

// Antd Components
import { Button, Row, Col, Spin, message, Table, Tabs } from "antd";
import {
  PlusOutlined,
  LoadingOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

// My Components
import NoAccess from "../Orders/NoAccess";
import instance from "../../store/actions/instance";
import { ReactComponent as OrdersIcon } from "../../assets/icons/invoice.svg";
import NewCampaignModal from "./NewCampaignModal";
import DetailCampaignModal from "./DetailCampaignModal";
import WhatsAppTemplates from "./WhatsAppTemplates";
import NewWhatsAppCampaignModal from "./NewWhatsAppCampaignModal";
import WhatsappDetailCampaignModal from "./WhatsappDetailCampaignModal";

const { TabPane } = Tabs;
const { Column } = Table;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

class Index extends Component {
  state = {
    loading: true,
    campaigns: [],
    detailModalOpen: false,
    selectedCampaign: null,
    selectedWhatsappCampaign: null,
    newWhatsAppModalOpen: false,
    newCampaignModalOpen: false,
    activeTab: "sms",
    activeWhatsAppSubTab: "template",
    newWhatsAppCampaignModalOpen: false,

    whatsappCampaigns: [],
    loadingWhatsAppCampaigns: false,
  };

  componentDidMount = () => {
    const { settings, whatsapp_settings } = this.props;
    this.fetchCampaigns();

    if (settings.enable_whatsapp_staff && whatsapp_settings?.is_active) {
      this.fetchWhatsAppCampaigns();
    }
  };

  fetchCampaigns = async () => {
    const { t } = this.props;
    try {
      const res = await instance.get("/fetch_sms_campaigns/");
      if (res.data.success) {
        this.setState({ campaigns: res.data.data, loading: false });
      } else {
        message.error(t("SomethingWentWrong"));
        this.setState({ loading: false });
      }
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
    }
  };

  fetchWhatsAppCampaigns = async () => {
    const { t } = this.props;
    this.setState({ loadingWhatsAppCampaigns: true });
    try {
      const res = await instance.get("/fetch_whatsapp_campaigns/");
      if (res.data.success) {
        this.setState({
          whatsappCampaigns: res.data.data,
          loadingWhatsAppCampaigns: false,
        });
      } else {
        message.error(t("SomethingWentWrong"));
        this.setState({ loadingWhatsAppCampaigns: false });
      }
    } catch (e) {
      console.error(e);
      this.setState({ loadingWhatsAppCampaigns: false });
    }
  };

  capitalizeFirstLetter = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1);

  handleOpenDetailModal = (campaign) => {
    this.setState({
      detailModalOpen: true,
      selectedCampaign: campaign,
    });
  };

  render() {
    const { config, t, permissions, settings, whatsapp_settings } = this.props;
    const {
      loading,
      campaigns,
      detailModalOpen,
      selectedCampaign,
      newCampaignModalOpen,
      activeTab,
      activeWhatsAppSubTab,
      newWhatsAppCampaignModalOpen,
      whatsappCampaigns,
      loadingWhatsAppCampaigns,
      selectedWhatsappCampaign,
    } = this.state;

    if (!permissions?.can_create_sms_campaigns) return <NoAccess />;

    const campaignData = campaigns.map((c) => ({ key: c.id, obj: c }));
    const whatsappCampaignData = whatsappCampaigns.map((c) => ({
      key: c.id,
      obj: c,
    }));

    const onCellProps = () => ({
      style: {
        textAlign: "center",
        cursor: "pointer",
      },
    });

    return (
      <div className="pageContainer">
        {/* Modals */}
        {newCampaignModalOpen && (
          <NewCampaignModal
            history={this.props.history}
            onClose={(newCampaigns) =>
              this.setState({
                newCampaignModalOpen: false,
                campaigns: newCampaigns || campaigns,
              })
            }
          />
        )}

        {detailModalOpen && (
          <DetailCampaignModal
            open={detailModalOpen}
            campaign={selectedCampaign}
            capitalizeFirstLetter={this.capitalizeFirstLetter}
            onClose={() =>
              this.setState({
                detailModalOpen: false,
                selectedCampaign: null,
              })
            }
          />
        )}
        {selectedWhatsappCampaign && (
          <WhatsappDetailCampaignModal
            open={selectedWhatsappCampaign}
            campaign={selectedWhatsappCampaign}
            capitalizeFirstLetter={this.capitalizeFirstLetter}
            onClose={() =>
              this.setState({
                selectedWhatsappCampaign: false,
              })
            }
          />
        )}

        {newWhatsAppCampaignModalOpen && (
          <NewWhatsAppCampaignModal
            visible={newWhatsAppCampaignModalOpen}
            onClose={(shouldUpdate) => {
              this.setState({ newWhatsAppCampaignModalOpen: false });
              if (shouldUpdate) {
                this.fetchWhatsAppCampaigns();
              }
            }}
            t={t}
          />
        )}

        <h1
          className={config.direction === "rtl" ? "pageArTitle" : "pageEnTitle"}
        >
          <OrdersIcon
            className={
              config.direction === "rtl" ? "pageArTitleIcon" : "pageEnTitleIcon"
            }
          />
          {t("Campaigns")}
        </h1>

        {/* Tabs */}
        <Tabs
          activeKey={activeTab}
          onChange={(key) => this.setState({ activeTab: key })}
        >
          {/* SMS Campaigns Tab */}
          <TabPane tab={t("SMS Campaigns")} key="sms">
            <Row gutter={[15, 8]}>
              <Col span={24}>
                <Button
                  type="link"
                  icon={<PlusOutlined />}
                  onClick={() => this.setState({ newCampaignModalOpen: true })}
                  style={{
                    float: config.direction === "ltr" ? "right" : "left",
                  }}
                >
                  {t("New Campaign")}
                </Button>
              </Col>
            </Row>

            <div className="whiteSubContainer" style={{ paddingBottom: 40 }}>
              {loading ? (
                <div className="mt-5 text-center">
                  <Spin indicator={antIcon} />
                </div>
              ) : (
                <Table
                  dataSource={campaignData}
                  pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "25", "50", "100"],
                  }}
                  onRow={(record) => ({
                    onClick: () => this.handleOpenDetailModal(record.obj),
                  })}
                >
                  <Column
                    title={t("Name")}
                    render={(text, record) => <div>{record.obj.name}</div>}
                    onCell={onCellProps}
                  />
                  <Column
                    title={t("Segment")}
                    render={(text, record) => (
                      <div>
                        {t(this.capitalizeFirstLetter(record.obj.segment))}
                      </div>
                    )}
                    onCell={onCellProps}
                  />
                  <Column
                    title={t("Reach")}
                    render={(text, record) => (
                      <div>
                        {record.obj.recipients?.split(",")?.length || 0}
                      </div>
                    )}
                    onCell={onCellProps}
                  />
                  <Column
                    title={t("Date")}
                    render={(text, record) => (
                      <div>
                        {moment(record.obj.created, "YYYY-MM-DD HH:mm")
                          .format("YYYY-MM-DD h:mm A")
                          .replace(
                            "AM",
                            config.language === "arabic" ? "ص" : "AM"
                          )
                          .replace(
                            "PM",
                            config.language === "arabic" ? "م" : "PM"
                          )}
                      </div>
                    )}
                    onCell={onCellProps}
                  />
                </Table>
              )}
            </div>
          </TabPane>

          {/* WhatsApp Tab with Inner Tabs */}
          {settings.enable_whatsapp_staff && whatsapp_settings?.is_active && (
            <TabPane tab={t("WhatsApp")} key="whatsapp">
              <Tabs
                activeKey={activeWhatsAppSubTab}
                onChange={(key) => this.setState({ activeWhatsAppSubTab: key })}
                type="card"
              >
                <TabPane tab={t("Templates")} key="template">
                  <Row gutter={[15, 8]}>
                    <Col span={24}>
                      <Button
                        type="link"
                        icon={<PlusOutlined />}
                        onClick={() =>
                          this.setState({ newWhatsAppModalOpen: true })
                        }
                        style={{
                          float: config.direction === "ltr" ? "right" : "left",
                        }}
                      >
                        {t("New WhatsApp Template")}
                      </Button>
                    </Col>
                  </Row>
                  <div
                    className="whiteSubContainer"
                    style={{ paddingBottom: 40 }}
                  >
                    <WhatsAppTemplates
                      newWhatsAppModalOpen={this.state.newWhatsAppModalOpen}
                      closeModal={() =>
                        this.setState({ newWhatsAppModalOpen: false })
                      }
                    />
                  </div>
                </TabPane>

                <TabPane tab={t("WhatsApp Campaigns")} key="campaign">
                  <Row gutter={[15, 8]}>
                    <Col span={24}>
                      <Button
                        type="link"
                        icon={<PlusOutlined />}
                        onClick={() =>
                          this.setState({ newWhatsAppCampaignModalOpen: true })
                        }
                        style={{
                          float: config.direction === "ltr" ? "right" : "left",
                        }}
                      >
                        {t("New WhatsApp Campaign")}
                      </Button>
                    </Col>
                  </Row>

                  <div
                    className="whiteSubContainer"
                    style={{ paddingBottom: 40, marginTop: 10 }}
                  >
                    {loadingWhatsAppCampaigns ? (
                      <div className="mt-5 text-center">
                        <Spin indicator={antIcon} />
                      </div>
                    ) : (
                      <Table
                        dataSource={whatsappCampaignData}
                        pagination={{
                          defaultPageSize: 10,
                          showSizeChanger: true,
                          pageSizeOptions: ["10", "25", "50", "100"],
                        }}
                        rowClassName={"text-center pointer"}
                        onRow={(record) => ({
                          onClick: () =>
                            this.setState({
                              selectedWhatsappCampaign: record.obj,
                            }),
                        })}
                      >
                        <Column
                          title={t("Name")}
                          render={(text, record) => (
                            <div>{record.obj.name}</div>
                          )}
                        />
                        <Column
                          title={t("Purpose")}
                          render={(text, record) => (
                            <div>{t(record.obj.purpose)}</div>
                          )}
                        />
                        <Column
                          title={t("Segment")}
                          render={(text, record) => (
                            <div>{t(record.obj.segment)}</div>
                          )}
                        />
                        <Column
                          title={t("Reach")}
                          render={(text, record) => (
                            <div>
                              {record.obj.recipients?.split(",")?.length || 0}
                            </div>
                          )}
                        />
                        <Column
                          title={t("Date")}
                          render={(text, record) => (
                            <div>
                              {moment(record.obj.created, "YYYY-MM-DD HH:mm")
                                .format("YYYY-MM-DD h:mm A")
                                .replace(
                                  "AM",
                                  config.language === "arabic" ? "ص" : "AM"
                                )
                                .replace(
                                  "PM",
                                  config.language === "arabic" ? "م" : "PM"
                                )}
                            </div>
                          )}
                        />
                      </Table>
                    )}
                  </div>
                </TabPane>
              </Tabs>
            </TabPane>
          )}
        </Tabs>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  config: state.config,
  settings: state.auth.settings,
  permissions: state.auth.permissions,
  whatsapp_settings: state.auth.settings.whatsapp_settings,
});

export default connect(mapStateToProps)(withNamespaces()(Index));
